import './dynamic-forms.css';

angular.module('skeyenoteWebApp').directive('dynamicForms', DynamicFormDirective);

function DynamicFormDirective($templateRequest, $compile) {
  return {
    restrict: 'AE',
    scope: {
      id: '=id',
      hide: '=hide',
      disable: '=disable',
      actiononchange: '=actiononchange',
      forms: '=forms',
      params: '=params',
      action: '=action',
      removeaction: '=removeaction',
    },

    link: function(scope, element, attrs, controller) {
      scope.loadForm = this.loadForm;
      scope.toggleCheckbox = this.toggleCheckbox;
      $templateRequest('app/notebook/dynamic-forms/dynamic-forms.directive.html').then(function(formsHtml) {
        let forms = angular.element(formsHtml);
        element.append(forms);
        $compile(forms)(scope);
      });
    },

    loadForm: function(formulaire, params) {
      let value = formulaire.defaultValue;
      if (params[formulaire.name]) {
        value = params[formulaire.name];
      }

      params[formulaire.name] = value;
    },

    toggleCheckbox: function(formulaire, option, params) {
      let idx = params[formulaire.name].indexOf(option.value);
      if (idx > -1) {
        params[formulaire.name].splice(idx, 1);
      } else {
        params[formulaire.name].push(option.value);
      }
    },

  };
}
